export default __webpack_public_path__ + "static/media/defaultAvatar.a70a5e73.svg";